export default {"src":"/_next/static/media/content_event_presence_event.654946e7.svg","height":500,"width":750,"blurWidth":0,"blurHeight":0};